import React, { Suspense, useContext } from 'react';
import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import BrowseEntitiesSkeleton from 'components/data-containers/BrowseEntities/SkeletonLoader';
import { EntityContext } from '../../context/entityContext';
import TopicFilters from 'components/TopicFilters/TopicFilters';

const BrowseRelated = React.lazy(
  () => import('components/data-containers/BrowseEntities/BrowseRelated') as any
);

const Label: React.FC = () => {
  const ctx = useContext(EntityContext);

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <TopicFilters topic="label" />
      <Suspense
        fallback={
          <BrowseEntitiesSkeleton
            title="Browse Related"
            browseEntityType="label"
            showToggle
            enableSearch
            browseRelated
            isBrowseTable
          />
        }
      >
        <BrowseRelated id="browse-related" {...ctx} entityTitle="Label" />
      </Suspense>

      <Layout.MaxWidth>
        <Message>
          No data available for labels. Select a track, release, project or
          artist to see related data.
        </Message>
      </Layout.MaxWidth>
    </div>
  );
};

export default Label;
